/** Recovered receipts invalidate current owned reads; they never replay an old row. */
const listeners = new Set<(userId: string) => void>();
export function subscribeNoteChanges(listener: (userId: string) => void) {
  listeners.add(listener); return () => { listeners.delete(listener); };
}
export function publishNoteRefresh(userId: string) { listeners.forEach(listener => listener(userId)); }
